import { render, staticRenderFns } from "./lezhi_project5.vue?vue&type=template&id=ca97d3fc&scoped=true&"
import script from "./lezhi_project5.vue?vue&type=script&lang=js&"
export * from "./lezhi_project5.vue?vue&type=script&lang=js&"
import style0 from "./lezhi_project5.vue?vue&type=style&index=0&id=ca97d3fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca97d3fc",
  null
  
)

export default component.exports